<template>
  <div>
    <div class="admin-toolbar">
      <p class="admin-subtitle">
        {{ users.length }} registered {{ users.length === 1 ? 'user' : 'users' }}
      </p>
      <div class="relative w-full sm:w-72">
        <i class="fa-solid fa-magnifying-glass pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-400"></i>
        <input v-model="search" type="search" placeholder="Search name, email or phone" class="form-input pl-9" />
      </div>
    </div>

    <div v-if="loading" class="admin-empty">Loading users...</div>
    <div v-else-if="error" class="admin-empty text-red-600">{{ error }}</div>
    <div v-else-if="filteredUsers.length === 0" class="admin-empty">
      <i class="fa-solid fa-users text-2xl text-gray-300"></i>
      {{ search ? 'No users match your search.' : 'No users found.' }}
    </div>
    <div v-else class="admin-table-wrap">
      <table class="admin-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Contact</th>
            <th>City</th>
            <th>District</th>
            <th>State</th>
            <th>Profile</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in filteredUsers" :key="user.id">
            <td class="font-medium text-gray-900">{{ user.name }}</td>
            <td>{{ user.email }}</td>
            <td class="whitespace-nowrap tabular-nums">{{ user.contact }}</td>
            <td>{{ user.city || 'N/A' }}</td>
            <td>{{ user.district || 'N/A' }}</td>
            <td>{{ user.state || 'N/A' }}</td>
            <td><span class="badge bg-gray-100 text-gray-700">{{ user.profile || 'user' }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import api, { errorMessage } from '@/api';

// State for users, loading, and error
const users = ref([]);
const loading = ref(false);
const error = ref(null);
const search = ref('');

const filteredUsers = computed(() => {
  const q = search.value.trim().toLowerCase();
  if (!q) return users.value;
  return users.value.filter(u =>
    [u.name, u.email, u.contact, u.city, u.district].some(v => String(v || '').toLowerCase().includes(q))
  );
});

// Fetch users from the backend
const fetchUsers = async () => {
  loading.value = true;
  error.value = null;
  try {
    const response = await api.get('/users');
    users.value = response.data;
  } catch (err) {
    error.value = errorMessage(err, 'Failed to fetch users');
  } finally {
    loading.value = false;
  }
};

// Fetch users when component is mounted
onMounted(fetchUsers);
</script>
